/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createApi } from '@reduxjs/toolkit/query/react';

import { JimboResponse, LoqateAddress } from '@models';
import { baseQueryWithReauth } from '@services/refreshToken.service';

export const loqateApi = createApi({
  reducerPath: 'loqateApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Loqate'],
  endpoints: (builder) => ({
    getFullAddress: builder.query<LoqateAddress[], { address: string }>({
      query: (query) => `/address/validate?address=${query.address}`,
      providesTags: ['Loqate'],
      transformResponse: (response: JimboResponse<LoqateAddress[]>) => response.data!,
    }),
    retreiveAddress: builder.query<LoqateAddress[], { addressId: string }>({
      query: (query) => `/address/retrieve?addressId=${query.addressId}`,
      providesTags: ['Loqate'],
      transformResponse: (response: JimboResponse<LoqateAddress[]>) => response.data!,
    }),
  }),
});

export const {
  // Search end points
  useGetFullAddressQuery,
  useRetreiveAddressQuery,
} = loqateApi;
